import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
//import { getPermissionLevel } from '../../helpers-roles';
import { WsAppContext } from '../AppContext';
import './HeaderMenu.scss';

const WsHeaderAdmin = (props: {}) => {
  const appContext = useContext(WsAppContext);

  let adminElement: JSX.Element | null = null;

  return (
    <>
      {appContext?.role === 'AVANADE' && (
        <NavLink
          className="navbar-item"
          to="/deliver/aida"
          onClick={(e) => e.currentTarget.blur()}
        >
          AIDA
        </NavLink>
      )}

      {/* {appContext?.role === 'AVANADE' && (
        <NavLink
          className="navbar-item"
          to="/deliver/config"
          onClick={(e) => e.currentTarget.blur()}
        >
          Configuration
        </NavLink>
      )} */}

      {/* <NavLink
        className="navbar-item decode"
        to="/deliver/decode"
        onClick={(e) => e.currentTarget.blur()}
      >
        Decode
      </NavLink> */}

      {/* {appContext?.role === 'AVANADE' && (
        <NavLink
          className="navbar-item"
          to="/deliver/apps"
          onClick={(e) => e.currentTarget.blur()}
        >
          Apps Hub
        </NavLink>
      )} */}

      {/* {appContext?.role === 'AVANADE' && (
        <NavLink
          className="navbar-item"
          to="/deliver/ai/dashboard"
          onClick={(e) => e.currentTarget.blur()}
        >
          AI Hub
        </NavLink>
      )} */}

      {/* {appContext?.role === 'AVANADE' && (
        <NavLink
          className="navbar-item"
          to="/deliver/copilot"
          onClick={(e) => e.currentTarget.blur()}
        >
          Copilot Hub
        </NavLink>
      )} */}

      {/* <NavLink className="navbar-item" to="/deliver/documentation" onClick={(e) => e.currentTarget.blur()}>Documentation</NavLink> */}

      {/* <NavLink className="navbar-item" to="/deliver/dsc" onClick={(e) => e.currentTarget.blur()}>DSC</NavLink> */}

      {/* <div className='decode-menu'> 
        <NavLink className="navbar-item decode" to="/deliver/decode" onClick={(e) => e.currentTarget.blur()}>Decode</NavLink>
        <ul className="submenu">
          <li>
            <NavLink className="navbar-item" to="/deliver/decode/dynamic360"  onClick={(e) => e.currentTarget.blur()}>
              Dynamic 360 Wheel
            </NavLink>
          </li>
        </ul> 
      </div> */}

      {/* <NavLink className="navbar-item" to="/deliver/deliver" onClick={(e) => e.currentTarget.blur()}>Deliver</NavLink> */}
      {/* <NavLink className="navbar-item" to="/deliver/cto" onClick={(e) => e.currentTarget.blur()}>CTO</NavLink> */}
      {/* <NavLink className="navbar-item" to="/deliver/servicing" onClick={(e) => e.currentTarget.blur()}>Servicing</NavLink> */}
    </>
  );
};

export { WsHeaderAdmin };
